/** 副作用模块相关的状态管理(src/modules/sideEffects) */
import * as types from '../mutation-types'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
import isNeedRefresh from 'utils/isNeedRefresh'
import choiceFilter from 'utils/choiceFilter'
import { isNewQuote } from 'utils/common'
import isSameStock from 'utils/isSameStock'

const state = {
  showAccountInfo: false,
  activeSideStock: null,
  orderDetail: null
}

const mutations = {
  [types.SET_ORDER_DETAIL]: (state, payload) => {
    state.orderDetail = payload
  },
  [types.SHOW_ACCOUNT_INFO]: (state, payload) => {
    state.showAccountInfo = payload
  },
  [types.SHOW_SIDE_STOCK_VIEW](state, detail) {
    state.activeSideStock = detail
  },
  [types.CLOSE_SIDE_STOCK_VIEW](state) {
    state.activeSideStock = null
  },
  [types.UPDATE_SIDE_STOCK](state, detail) {
    if (
      isSameStock(state.activeSideStock, detail) &&
      isNewQuote(state.activeSideStock, detail)
    ) {
      Object.assign(state.activeSideStock, detail)
    }
  }
}
const getters = {
  orderDetail(state) {
    return state.orderDetail
  },
  isShowSideStockView(state) {
    return !!state.activeSideStock
  },
  isSideStockNeedRefresh(state, getters) {
    return isNeedRefresh(state.activeSideStock, getters)
  },
  activeSideStock(state) {
    const stock = state.activeSideStock
    if (!stock) return {}
    stock.digits = choiceFilter(stock)
    return stock
  }
}
const actions = {
  setOrderDetail({ commit }, detail) {
    commit(types.SET_ORDER_DETAIL, detail)
  },
  openSideStockView({ commit }, request) {
    request.secType = request.secType || SEC_TYPE.STK
    if (request.secType === SEC_TYPE.OPT) {
      commit(types.SHOW_SIDE_STOCK_VIEW, request)
    } else {
      const stock = {
        secType: request.secType,
        symbol: request.symbol,
        name: request.name || '',
        nameCN: request.nameCN || request.name || '',
        market: request.market || MARKET_TYPE.US
      }
      commit(types.SHOW_SIDE_STOCK_VIEW, stock)
    }
  },
  closeSideStockView({ commit }) {
    commit(types.CLOSE_SIDE_STOCK_VIEW)
  },
  updateSideStockView({ commit }, stock) {
    commit(types.UPDATE_SIDE_STOCK, stock)
  },
  whenStockUpdate({ commit }, stock) {
    commit(types.UPDATE_SIDE_STOCK, stock)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
